<template>
  <div class="language-selector__content">
    <ul class="language-selector__list" translate="no">
      <li class="language-selector__list">
        <a
          v-for="language in staticLanguages"
          :key="language.code"
          :href="language.href"
          class="language-selector__option"
          @click.prevent="changeLanguage(language.code)"
        >
          {{ language.label }}
        </a>
      </li>
    </ul>
    <div class="language-selector__divider"></div>
    <ul class="language-selector__list" translate="no">
      <li
        v-for="language in conwordLanguages"
        :key="language.code"
        class="language-selector__item"
      >
        <button
          type="button"
          class="language-selector__option"
          @click="changeLanguage(language.code)"
        >
          {{ language.label }}
        </button>
      </li>
    </ul>
    <div class="language-selector__description">
      <slot name="description" />
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick, toRefs, defineProps } from 'vue';
import { useConword } from '@/shared/js/composables/use-conword';

const props = defineProps({
  languageList: {
    type: Array,
    required: true,
  },
});

const { languageList } = toRefs(props);

const { languageCode } = useConword({
  disabledLanguageCodeList: [
    languageList.value.filter(lang => !!lang.href).map(lang => lang.code),
  ],
});

const emit = defineEmits(['select']);

const getLanguageByCode = code => {
  return languageList.value.find(lang => lang.code === code);
};

const availableLanguages = computed(() => {
  return languageList.value.filter(lang => lang.code !== languageCode.value);
});

const staticLanguages = computed(() => {
  return availableLanguages.value.filter(lang => lang.href);
});

const conwordLanguages = computed(() => {
  return availableLanguages.value.filter(lang => !lang.href);
});

const changeLanguage = async selectedLanguageCode => {
  languageCode.value = selectedLanguageCode;
  await nextTick();
  const href = getLanguageByCode(selectedLanguageCode)?.href;
  if (href) {
    window.location.href = href;
    return;
  }
  emit('select', languageCode.value);
};
</script>
